import { useWriteContract } from "@abraxas/ui/web3"
import { OfferParams } from "../types"
import { parseEventLogs } from "viem"
import { TransactionReceipt } from "viem"
import { useCallback } from "react"
import { ABIOffersLogic } from "../abis/OffersLogic"
import { MARKETPLACE_CHAIN_ID } from "../marketplace-chain-id"
import { config } from "@repo/loomlock/client"

export function useMakeOffer() {
  const { writeContractAsync, isPending } = useWriteContract("make-offer")

  const makeOffer = useCallback(
    async (params: OfferParams) => {
      const marketplace = config[MARKETPLACE_CHAIN_ID]?.contracts.marketplace
      const receipt = (await writeContractAsync({
        address: marketplace!,
        abi: ABIOffersLogic,
        functionName: "makeOffer",
        args: [params],
        chainId: MARKETPLACE_CHAIN_ID,
        loading: "Making offer...",
        success: "Offer created successfully!",
        error: "Failed to create offer",
      })) as unknown as TransactionReceipt

      const logs = parseEventLogs({
        logs: receipt.logs,
        abi: ABIOffersLogic,
      }) as any

      const offerCreatedEvent = logs.find(
        (log) => log.eventName === "OfferCreated",
      )
      const offerId = offerCreatedEvent?.args?.offerId

      return {
        receipt,
        offerId,
      }
    },
    [writeContractAsync],
  )

  return {
    makeOffer,
    isPending,
  }
}
